// extracted by mini-css-extract-plugin
export default {"banner":"TermsOfServiceUpdatedBanner_banner__muFCo","closeLabel":"TermsOfServiceUpdatedBanner_closeLabel__kRiij","link":"TermsOfServiceUpdatedBanner_link__v0F9U"};